export default __webpack_public_path__ + "static/media/Yodha_Logo.89e6036f.png";